import { Box } from '@mui/material'

export const NavigateToMain = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        display: 'block',
        left: -9999,
        zIndex: 1e9,
        '&:has(a:focus), &:has(a:active)': {
          left: 0,
        },
        '&>a': {
          padding: 1,
        },
      }}
    >
      <a href="#main">Skip to main</a>
    </Box>
  )
}
